/**
 * Utility functions for handling redirects based on authentication state
 */

/**
 * Returns the appropriate redirect URL based on authentication status
 * - Authenticated users: redirected to dashboard
 * - Unauthenticated users: redirected to signup
 */
export const getAuthRedirectUrl = (isAuthenticated: boolean): string => {
  return isAuthenticated ? '/client-dashboard' : '/auth/signup';
};
